module.exports = __webpack_public_path__ + "img/header.fcda33a1.png";